import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:project',
    name: 'SearchStop',
    component: () => import(/* webpackChunkName: "search-stop" */ '../views/SearchStop.vue')
  },
  {
    path: '/:project/:stop',
    name: 'ProximasPartidas',
    component: () => import(/* webpackChunkName: "proximas-partidas" */ '../views/ProximasPartidas.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/proximas-partidas',
  routes
})

export default router
